module.exports = __webpack_public_path__ + "sm.svg?f859e5c9a1369bc8eda549b540a555bf";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sm.svg
// module id = 1379
// module chunks = 27